import { render, staticRenderFns } from "./part-h.vue?vue&type=template&id=12c0bf15&"
import script from "./part-h.vue?vue&type=script&lang=js&"
export * from "./part-h.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports